import React, { useEffect, useState, useCallback } from 'react';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';
import { PermissiongroupForm, } from '../../components';
import { withLoadPanel } from '../../utils/withLoadPanel';
import './permissiongroup_edit.scss';
import ScrollView from 'devextreme-react/scroll-view';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiToken } from '../../utils/authUtils.js';
import notify from 'devextreme/ui/notify';
import axios from 'axios';
import { useMsal } from "@azure/msal-react";

const PermissiongroupFormWithLoadPanel = withLoadPanel(PermissiongroupForm);
export const PermissiongroupDetails = () => {
      const { instance, accounts } = useMsal();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);

    let { permissiongroupId } = useParams()
    const navigate = useNavigate();

    const onLeftClick = () => {
        navigate(-1);
    };
    useEffect(() => {
        loadData();
    }, []);

    const loadData = useCallback(() => {

        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'permissiongroupId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/Permissiongroups`,
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/InsertPermissiongroup`,
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/UpdatePermissiongroup`,
                deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/DeletePermissiongroup`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            const dataSource_permission = createStore({
                key: 'permissionId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Permission/Permissions`,
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/Permission/InsertPermission`,
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Permission/UpdatePermission`,
                deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Permission/DeletePermission`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            const dataSource_permissiongroupPermission = createStore({
                key: 'permissiongroupPermissionId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/PermissiongroupPermission/PermissiongroupPermissions`,
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/PermissiongroupPermission/InsertPermissiongroupPermission`,
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/PermissiongroupPermission/UpdatePermissiongroupPermission`,
                deleteUrl: `${process.env.REACT_APP_serverEndpoint}/PermissiongroupPermission/DeletePermissiongroupPermission`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });


            Promise.all([
                dataSource.load({ filter: ['permissiongroupId', '=', permissiongroupId] }),
                dataSource_permission.load(),
                dataSource_permissiongroupPermission.load({ filter: ['permissiongroupId', '=', permissiongroupId], select: ['permissionId'] })


            ]).then((values) => {
                var selectedRowKeys_2 = [];
                values[2].forEach(element => {
                    selectedRowKeys_2.push(element.permissionId)
                });
                setData({ permissiongroup: values[0][0], permissions: values[1], permissiongrouppermissions: selectedRowKeys_2 }); setIsLoading(false);
            }).catch((error) => console.log(error));


        });

    }, []);

    const refresh = useCallback(() => {
        setIsLoading(true);
        loadData();
    }, []);
    const onSave = useCallback((data) => {

        getApiToken(instance, accounts).then(token => {


            axios.post(`${process.env.REACT_APP_serverEndpoint}/Permissiongroup/SavePermission`, { keys: data, permissiongroupId: permissiongroupId }, { headers: { Authorization: `Bearer ${token}` } })
                .then(response => {
                    if (response.data.success == true) {
                        notify({
                            message: `Berechtigungsgruppe gespeichert`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        },
                            'success'
                        );


                    } else {
                        notify("Speichern nicht erfolgreich", "error", 3000);
                    }

                })
                .catch(error => {
                    console.error(error);
                    notify("Speichern nicht erfolgreich", "error", 3000);
                });



        })



    }, []);

    return (
        <ScrollView className='view-wrapper-scroll'>
            <div className='view-wrapper view-wrapper-permissiongroup-details'>
                <Toolbar className='toolbar-details theme-dependent'>
                    <Item location='before'>
                        <Button icon='arrowleft' stylingMode='text' onClick={onLeftClick} />
                    </Item>
                    <Item location='before' text={function () {
                        if (!!data) {

                            return data?.permissiongroup?.permissiongroupname
                        } else {
                            return 'Lädt...'
                        }

                    }} />

                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Refresh'
                            icon='refresh'
                            stylingMode='text'
                            onClick={refresh}
                        />
                    </Item>
                </Toolbar>

                <div className='panels'>
                    <div className='left'>
                        <PermissiongroupFormWithLoadPanel
                            loading={isLoading}
                            hasData={!!data}
                            data={data}
                            onSave={onSave}
                        />
                    </div>


                </div>
            </div>
        </ScrollView>
    );
};


